import React, { Component } from "react";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const common = require('./common');

const STEP_LABELS = [
  "Complaint Received",                          // 0
  "Under Review",                                // 1
  "In Progress",                                 // 2
  "Remote Support (Audio/Video/Remote Desktop)", // 3
  "Site Visit Scheduled",                        // 4
  "Resolved",                                    // 5
  "Pending Payment",                             // 6
  "Closed"                                       // 7
];

// Stages that the stored `status` column can represent
const STATUS_INDEX = {
  "Complaint Received": 0,
  "Under Review": 1,
  "In Progress": 2,
  "Resolved": 5
};

class CheckStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      invalidComplaintId: false,
      complaintId: "",
      data: [],
      loaded: false
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const params = new URLSearchParams(this.props.location.search);
    const complaintId = params.get('complaint-id');

    // 36 characters, letters/digits/hyphens only
    const isValid = complaintId && /^[a-zA-Z0-9-]{36}$/.test(complaintId);

    if (isValid) {
      this.setState({ complaintId: complaintId, invalidComplaintId: false });
      this.getData(complaintId);
    } else {
      this.setState({
        error: false,
        complaintId: "Please enter Valid Complaint ID",
        invalidComplaintId: true
      });
    }
  }

  getData = (complaintId) => {
    const link = common.getBasePath().concat('service/getComplaintStatus');
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ complaintId: complaintId })
    };

    fetch(link, requestOptions)
      .then(res => res.json())
      .then(res => {
        if (res.error) {
          this.setState({ error: true });
        } else if (res.loginRequired) {
          common.signOutUser();
          this.setState({ error: res.error, loginRequired: true, adminRequired: false });
        } else if (res.adminRequired) {
          this.setState({ error: res.error, loginRequired: false, adminRequired: true });
        } else {
          this.setState({
            error: res.error,
            loginRequired: false,
            adminRequired: false,
            data: res.data || [],
            loaded: true
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ error: true });
      });
  }

    // Works out the state of every step for one complaint row.
  // State is one of: 'completed' | 'active' | 'pending' | 'skipped'
  getStepStates = (element) => {
    const remoteGiven = element.remote_support_given === 'Yes';
    const siteScheduled = element.site_visit_scheduled === 'Yes';
    const invoiceAmount = Number(element.invoice_amount) || 0;
    const paymentReceived = !!element.payment_received_date;
    const closed = !!element.closed_date;

    // Furthest stage reached
    let reached = STATUS_INDEX[element.status] || 0;
    if (remoteGiven) reached = Math.max(reached, 3);
    if (siteScheduled) reached = Math.max(reached, 4);
    if (invoiceAmount > 0) reached = Math.max(reached, 6);
    if (closed) reached = 7;

    return STEP_LABELS.map((label, i) => {
      const movedPast = reached > i; // progress is beyond this stage

      // Optional steps: strikethrough only once progress has moved past them
      if (i === 3 && !remoteGiven) {
        return { label, state: movedPast ? 'skipped' : 'pending' };
      }
      if (i === 4 && !siteScheduled) {
        return { label, state: movedPast ? 'skipped' : 'pending' };
      }

      if (i === 6) {
        if (invoiceAmount <= 0) {
          return { label, state: movedPast ? 'skipped' : 'pending' };
        }
        if (paymentReceived) return { label: "Payment Received", state: 'completed' };
        return { label, state: 'active' }; // invoice raised, payment still pending
      }

      if (movedPast) return { label, state: 'completed' };
      if (i === reached) return { label, state: 'active' };
      return { label, state: 'pending' };
    });
  }

    renderTracker = (element) => {
    if (element.complaint_rejected === 'Yes') {
      const reason = (element.complaint_rejected_reason || '').trim();

      return (
        <div className="alert alert-danger mb-0">
          <strong>Complaint Rejected</strong>
          {reason.length > 0 && (
            <div className="mt-2" style={{ whiteSpace: 'pre-wrap' }}>
              <span className="small text-uppercase">Reason:</span> {reason}
            </div>
          )}
        </div>
      );
    }

    return (
      <div className="status-tracker">
        {this.getStepStates(element).map((step, idx) => (
          <div
            key={idx}
            className={`step-item ${step.state === 'active' ? 'active' : ''} ${step.state === 'completed' ? 'completed' : ''} ${step.state === 'skipped' ? 'skipped' : ''}`}
            style={step.state === 'skipped' ? { opacity: 0.5 } : undefined}
          >
            <div className="step-dot"></div>
            <div
              className="step-label"
              style={step.state === 'skipped' ? { textDecoration: 'line-through' } : undefined}
            >
              {step.label}
            </div>
          </div>
        ))}
      </div>
    );
  }

  getCurrentProgress = () => {
    const items = this.state.data.map((element, i) => (
      <div key={i} className="col-12 border-top mt-4 pt-3">
        <label className="form-label text-muted small mb-3">
          {element.job_number_customer_entered} | {element.name_of_equipment}
        </label>
        {this.renderTracker(element)}
      </div>
    ));

    return (
      <div className="row g-3">
        {/* Complaint ID Section */}
        <div className="col-12">
          <label htmlFor="ComplaintID" className="form-label text-muted small uppercase">Complaint ID</label>
          <h4 id="ComplaintID" style={{ color: this.state.invalidComplaintId ? 'red' : 'inherit' }}>
            {this.state.complaintId || "N/A"}
          </h4>
        </div>

        {/* Visual Status Tracker */}
        {items}

        {this.state.loaded && this.state.data.length === 0 && (
          <div className="col-12 border-top mt-4 pt-3 text-muted">
            No complaint found for this ID.
          </div>
        )}
      </div>
    );
  }

  render() {
    if (this.state.error) {
      return common.redirectToError();
    }

    return (
      <div className="container2 m-0">
        <main>
          <div className="py-5 text-center">
            <img className="d-block mx-auto mb-4" src="./scrlogo.png" alt="SCR Logo" width="72" height="72" />
            <h2>Complaint Status</h2>
            <p className="lead">Tracking your resolution, every step of the way</p>
          </div>

          <div className="row g-5 justify-content-center">
            <div className="col-md-9 col-lg-9">
              <div className="card shadow-sm p-4">
                <div className="row g-3">
                  {this.getCurrentProgress()}
                </div>
              </div>
            </div>
          </div>
        </main>

        <ToastContainer />
        <footer className="my-5 pt-5 text-muted text-center text-small">
          <p className="mb-1">&copy; {new Date().getFullYear()} SCR ELEKTRONIKS PRIVATE LIMITED</p>
        </footer>
      </div>
    );
  }
}

export default CheckStatus;